export const autoSellQuality = [
  { name: '关闭', key: '' },
  { name: '普通', key: 'normal' },
  { name: '稀有', key: 'race' },
  { name: '低阶史诗', key: 'special' },
  { name: '史诗', key: 'epic' },
  { name: '独特', key: 'unique' },
  { name: '传说', key: 'legend' },
  { name: '远古', key: 'antiquity' },
  { name: '绝世', key: 'peerless' },
  { name: '暗金', key: 'darkGold' },
]

export const commonMailTitleList = ['BOSS击败奖励', '每日挑战奖励']

export type MailCategory = 'common' | 'dungeon' | 'special'

/** Boss击败奖励标题集合 */
const bossTitles = new Set(['BOSS击败奖励', '每日挑战奖励', '每日挑战扫荡奖励'])

/** 副本奖励标题集合 */
const dungeonTitles = new Set([
  '不朽之塔奖励',
  '不朽之塔扫荡奖励',
  '魔物巢穴奖励',
  '魔物巢穴扫荡奖励',
  '符石尖塔奖励',
  '符石尖塔扫荡奖励',
  '符石遗迹奖励',
  '符石神殿奖励',
  '虚空裂隙奖励',
  '大荒野奖励',
  '无尽之塔奖励',
  '无尽之塔扫荡奖励',
  '圣物遗迹奖励',
  '鎏金神殿奖励',
  '无垠之塔奖励',
  '无垠之塔扫荡奖励',
  '魔物旷野奖励',
  '秘技回廊奖励',
])

export const mailCategoryList: { key: MailCategory; label: string; icon: string }[] = [
  { key: 'common', label: '常见邮件', icon: '⚔️' },
  { key: 'dungeon', label: '副本邮件', icon: '🏰' },
  { key: 'special', label: '特殊邮件', icon: '⭐' },
]

export function getMailCategory(title: string): MailCategory {
  if (bossTitles.has(title)) return 'common'
  if (dungeonTitles.has(title)) return 'dungeon'
  return 'special'
}
